import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Facebook, Instagram, Youtube } from 'lucide-react';
import keylogo from '../assets/logo.png';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Developments', path: '/developments' },
    { name: 'Customer Care', path: '/customer-care' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container-custom">
        <div className="flex justify-between items-center py-4 px-4 sm:px-6 md:px-6 lg:px-8 xl:px-10 relative">
{/* Logo */}
<Link to="/" className="flex items-center space-x-2">
  <div className="w-14 h-14 rounded-full overflow-hidden flex items-center justify-center">
    <img
      src={keylogo}
      alt="Golden Generation Logo"
      className="w-full h-full object-cover scale-150"
      style={{ transform: 'scale(1.5) translateX(-2%)' }}
    />
  </div>



            <div className="hidden sm:block">
              <h1 className="text-xl font-bold text-dark-gray">GOLDEN GENERATION</h1>
              <p className="text-sm text-golden">INVESTMENT PARTNERS</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8 ml-auto">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`font-medium transition-colors duration-300 ${
                  isActive(item.path)
                    ? 'text-golden border-b-2 border-golden'
                    : 'text-dark-gray hover:text-golden'
                }`}
              >
                {item.name}
              </Link>
            ))}

            {/* Social Links */}
            <div className="flex items-center space-x-4 pl-4 border-l border-gray-200">
              <a
                href="https://www.facebook.com/profile.php?id=61577843392607"
                target="_blank"
                rel="noreferrer"
                className="text-dark-gray hover:text-golden transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/goldengeneration.ip/"
                target="_blank"
                rel="noreferrer"
                className="text-dark-gray hover:text-golden transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.youtube.com/@GoldenGeneration_ip"
                target="_blank"
                rel="noreferrer"
                className="text-dark-gray hover:text-golden transition-colors"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Hamburger Menu - Navbar içinde, şeffaf */}
          <div 
            className="lg:hidden relative"
            onMouseEnter={() => {
              setIsMenuOpen(true);
            }}
            onMouseLeave={() => {
              setIsMenuOpen(false);
            }}
          >
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-3 text-dark-gray hover:text-golden transition-colors duration-300"
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
            
            {/* Tek Menü - Sağdan sola doğru açılan, sayfanın en üstüne uzanan */}
            {isMenuOpen && (
              <div 
                className="fixed top-0 right-0 w-80 h-screen bg-white/90 backdrop-blur-sm shadow-2xl border-l border-gray-100 z-50"
                style={{
                  animation: 'slideInFromRight 0.8s ease-out forwards'
                }}
                onMouseEnter={() => setIsMenuOpen(true)}
                onMouseLeave={() => {
                  setIsMenuOpen(false);
                }}
              >
                <div className="py-8">
                  {/* Üç çizgi butonu menü içinde */}
                  <div className="px-8 py-4 border-b border-gray-200">
                    <button
                      onClick={() => setIsMenuOpen(!isMenuOpen)}
                      className="flex items-center justify-center text-dark-gray hover:text-golden transition-colors duration-300"
                    >
                      {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
                    </button>
                  </div>
                  
                  {/* Menü öğeleri */}
                  <div className="mt-8">
                    {navItems.map((item, index) => (
                      <Link
                        key={item.name}
                        to={item.path}
                        className={`block px-8 py-5 text-lg font-semibold transition-all duration-300 hover:bg-golden/10 hover:text-golden hover:scale-105 ${
                          isActive(item.path)
                            ? 'text-golden bg-golden/5 border-l-4 border-golden'
                            : 'text-dark-gray'
                        }`}
                        style={{
                          animationDelay: `${(index + 1) * 200}ms`,
                          animation: 'fadeInUp 0.8s ease-out forwards'
                        }}
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>

                  {/* Mobile Social Links */}
                  <div className="mt-8 px-8 flex space-x-4">
                    <a
                      href="https://www.facebook.com/profile.php?id=61577843392607"
                      target="_blank"
                      rel="noreferrer"
                      className="text-dark-gray hover:text-golden transition-colors"
                    >
                      <Facebook size={20} />
                    </a>
                    <a
                      href="https://www.instagram.com/goldengeneration.ip/"
                      target="_blank"
                      rel="noreferrer"
                      className="text-dark-gray hover:text-golden transition-colors"
                    >
                      <Instagram size={20} />
                    </a>
                    <a
                      href="https://www.youtube.com/@GoldenGeneration_ip"
                      target="_blank"
                      rel="noreferrer"
                      className="text-dark-gray hover:text-golden transition-colors"
                    >
                      <Youtube size={20} />
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;
